module.exports = __webpack_public_path__ + "static/media/admin_manual.ef1e4aaf.pdf";